<template>
  <div class="radio">
    <el-radio-group
      v-model="answer.value"
      @change="radioChange"
    >
      <el-radio
        v-for="option in question.optionList"
        :key="option"
        :label="option"
      >
      </el-radio>
    </el-radio-group>
    <div v-show="selectShow">
      <div class="question-title">
        <span>
          挂账公司<span class="question-title-require">
            *
          </span>
        </span>

      </div>
      <div>
        <el-select
          v-model="answer.tj_companyId"
          placeholder="请选择"
          filterable
          remote
          ref="select"
          :remote-method="bookCompanyList"
          @change="selectChange"
        >
          <el-option
            v-for="item in companyList"
            :key="item.companyId"
            :label="item.comanyName"
            :value="item.companyId"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <input
      type="text"
      id="_focus_input"
    >
  </div>
</template>

<script>
import mixins from "./mixins";
import menZhenService from "@/apis/menZhen/index.js";

export default {
  name: "PayType",
  mixins: [mixins],
  data() {
    return {
      answer: {
        value: "",
      },
      companyList: [],
      selectShow: false,
    };
  },
  created() {
    this.bookCompanyList();
  },
  mounted() {
    Array.from(document.getElementsByClassName("el-select")).forEach((item) => {
      item.children[0].children[0].removeAttribute("readOnly");
      item.children[0].children[0].onblur = function () {
        let _this = this;
        setTimeout(() => {
          _this.removeAttribute("readOnly");
        }, 200);
      };
    });
  },
  methods: {
    radioChange(option) {
      if (option === "挂账机构") {
        this.selectShow = true;
      } else {
        this.answer.tj_companyId = undefined;
        this.answer.tj_comanyName = undefined;
        this.selectShow = false;
      }
      this.answerChange(this.answer);
    },
    selectChange(id) {
      const { companyList } = this;
      setTimeout(() => {
        document.querySelector("#_focus_input").focus();
      }, 100);
      companyList.some((item) => {
        if (item.companyId === id) {
          this.answer.tj_comanyName = item.comanyName;
          return true;
        }
      });
      this.answerChange(this.answer);
    },
    bookCompanyList(keyWord = "") {
      const params = {
        companyName: keyWord,
      };
      menZhenService.bookCompanyList(params).then((res) => {
        this.companyList = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#_focus_input {
  position: fixed;
  top: -2000px;
}
</style>